import { render } from "./AddModal_Soshiki.vue?vue&type=template&id=0164f25c"
import script from "./AddModal_Soshiki.vue?vue&type=script&lang=js"
export * from "./AddModal_Soshiki.vue?vue&type=script&lang=js"

import "./AddModal_Soshiki.vue?vue&type=style&index=0&id=0164f25c&lang=css"

import exportComponent from "/codebuild/output/src327471177/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__